module.exports = __webpack_public_path__ + "img/hand-a.818614c9.png";